import React, { useCallback, useContext } from "react";
import JQ from "jquery";
import cadviewer from "cadviewer";
import { handle_selector, selected_handles, current_selected_handle } from "../../CADViewer/CADViewer";
import { is } from "css-select";
import { CadviewerContext } from "../../../context/Cadviewer.Context";
import useConfig from "../../../demos/hooks/useConfig";


export const CADViewerCustomCanvas = () => {
	const { config } = useConfig();
	const { handleSelector, setHandleSelector, currentCanvasInstance } = useContext(CadviewerContext);


	/////////  CANVAS CONTROL METHODS START

	///  HERE ARE ALL THE CUSTOM TEMPLATES TO DO STUFF ON THE CANVAS

	var generic_canvas_flag_first_click_rectangle = false;
	var generic_canvas_flag_rectangle = false;
	var tPath_r = "";
	var cvjs_RubberBand: any;
	var cvjs_firstX = 0;
	var cvjs_firstY = 0;
	var cvjs_lastX = 0;
	var cvjs_lastY = 0;

	var selected_handles: any;  // this is just to show that you can have multiple handles
	var handle_selector = false;
	var current_selected_handle = "";


	const cadviewerCanvasMethod01 = useCallback(() => {

		cadviewer.cvjs_executeCustomCanvasMethod_drag(
			generic_start_method_01,
			generic_stop_method_01,
			generic_move_method_01,
			""
		);


	}, [currentCanvasInstance]);


	const cadviewerCanvasMethod02 = useCallback(() => {

		cadviewer.cvjs_executeCustomCanvasMethod_click(
			generic_mousemove_method_01,
			generic_mousedown_method_01,
			generic_mouseup_method_01,
			generic_dblclick_method_01,
			""
		);


	}, [currentCanvasInstance]);

	const cadviewerCanvasMethod03 = useCallback(() => {

		cadviewer.cvjs_executeCustomCanvasMethod_click(
			generic_make_rect_mousemove_method,
			generic_make_rect_mousedown_method,
			generic_make_rect_mouseup_method,
			"",
			generic_make_rect_init_method
		);


	}, [currentCanvasInstance]);

	const cadviewerCanvasMethod04 = useCallback(() => {

		cadviewer.cvjs_executeCustomCanvasMethod_drag(
			generic_drag_rect_start,
			generic_drag_rect_stop,
			generic_drag_rect_move,
			""
		);


	}, [currentCanvasInstance]);

	const cadviewerCanvasMethod05 = useCallback(() => {

		cadviewer.cvjs_executeCustomCanvasMethod_drag(
			select_drag_rect_start,
			select_drag_rect_stop,
			select_drag_rect_move,
			""
		);


	}, [currentCanvasInstance]);




	const cadviewerCanvasMethod05A = useCallback(() => {

		cadviewer.cvjs_executeCustomCanvasMethod_drag(
			select_drag_rect_start,
			select_drag_rect_stop_highlight,
			select_drag_rect_move,
			""
		);


	}, [currentCanvasInstance]);










	const cadviewerCanvasMethod06 = useCallback(() => {

		cadviewer.cvjs_executeCustomCanvasMethod_click(
			generic_make_rect_arrow_mousemove_method,
			generic_make_rect_arrow_mousedown_method,
			generic_make_rect_arrow_mouseup_method,
			generic_make_rect_arrow_dblclick_method,
			generic_make_rect_arrow_init_method
		);


	}, [currentCanvasInstance]);


	const cadviewerCanvasMethod07 = useCallback(() => {

		cadviewer.cvjs_executeCustomCanvasMethod_click(
			generic_handles_mousemove_method_01,
			generic_handles_mousedown_method_01,
			generic_handles_mouseup_method_01,
			generic_handles_dblclick_method_01,
			generic_handles_init_method_01
		);


	}, [currentCanvasInstance]);


	///// DRAG + CLICK ON CANVAS  - CONSOLE

	/**
	 * Template start drag method for custom canvas
	 */

	var generic_start_method_01 = function () {
		console.log("generic_start_method_01");
	};

	/**
	 * Template move drag method for custom canvas
	 */
	var generic_move_method_01 = function (dx: number, dy: number, x: number, y: number) {
		var svg_x = cadviewer.cvjs_SVG_x(x);
		var svg_y = cadviewer.cvjs_SVG_y(y);
		console.log(
			"generic_move_method_01: dx=" +
			dx +
			" dy=" +
			dy +
			" x=" +
			x +
			" y=" +
			y +
			" svg_x=" +
			svg_x +
			"  svg_y=" +
			svg_y
		);
	};

	/**
	 * Template stop drag method for custom canvas
	 */
	var generic_stop_method_01 = function () {
		cadviewer.cvjs_removeCustomCanvasMethod();
		console.log("REMOVE: generic_stop_method_01");
	};

	/**
	 * Template mouse-move method for custom canvas
	 */

	var generic_mousemove_method_01 = function (e: any, x: number, y: number) {
		var svg_x = cadviewer.cvjs_SVG_x(x);
		var svg_y = cadviewer.cvjs_SVG_y(y);

		//cadviewer.cvjs_removeCustomCanvasMethod();
		console.log(
			"generic_mousemove_method_01: x=" +
			x +
			" y=" +
			y +
			" svg_x=" +
			svg_x +
			"  svg_y=" +
			svg_y
		);
	};

	/**
	 * Template mouse-down method for custom canvas
	 */

	var generic_mousedown_method_01 = function (e: any, x: number, y: number) {
		var svg_x = cadviewer.cvjs_SVG_x(x);
		var svg_y = cadviewer.cvjs_SVG_y(y);

		//cadviewer.cvjs_removeCustomCanvasMethod();
		console.log(
			"generic_mousedown_method_01: x=" +
			x +
			" y=" +
			y +
			" svg_x=" +
			svg_x +
			"  svg_y=" +
			svg_y
		);
	};

	/**
	 * Template mouse-up method for custom canvas
	 */

	var generic_mouseup_method_01 = function (e: any, x: number, y: number) {
		var svg_x = cadviewer.cvjs_SVG_x(x);
		var svg_y = cadviewer.cvjs_SVG_y(y);

		console.log(
			"generic_mouseup_method_01: x=" +
			x +
			" y=" +
			y +
			" svg_x=" +
			svg_x +
			"  svg_y=" +
			svg_y
		);
	};

	/**
	 * Template double-click method for custom canvas
	 */

	var generic_dblclick_method_01 = function (e: any, x: number, y: number) {
		cadviewer.cvjs_removeCustomCanvasMethod();

		var svg_x = cadviewer.cvjs_SVG_x(x);
		var svg_y = cadviewer.cvjs_SVG_y(y);
		console.log(
			"REMOVE: generic_dblclick_method_01: x=" +
			x +
			" y=" +
			y +
			" svg_x=" +
			svg_x +
			"  svg_y=" +
			svg_y
		);
	};

	///// DRAG + CLICK ON CANVAS  - CONSOLE

	// SAMPLE TO CREATE RECTANGLE BY CLICK

	var generic_make_rect_init_method = function () {
		console.log("generic_make_rect_init_method");
		generic_canvas_flag_first_click_rectangle = false;
		generic_canvas_flag_rectangle = false;
	};

	var generic_make_rect_mousedown_method = function (e: any, x: number, y: number) {
		try {
			console.log("generic_make_rect_mousedown_method");

			if (!generic_canvas_flag_first_click_rectangle) {
				var tPath_r = "M" + 0 + "," + 0;
				cvjs_RubberBand = cadviewer
					.cvjs_makeGraphicsObjectOnCanvas("Path", tPath_r)
					.attr({ stroke: "#b00000", fill: "none", "stroke-width": 0.5 });
				generic_canvas_flag_first_click_rectangle = true;
				generic_canvas_flag_rectangle = false;
				console.log("rubberband");
			} else {
				console.log(
					generic_canvas_flag_first_click_rectangle +
					"  " +
					generic_canvas_flag_rectangle
				);
				if (generic_canvas_flag_rectangle) {
					generic_make_rect_stop_method();
				}
			}
		} catch (err) {
			console.log(err);
		}
		//console.log("mouse down ");
	};

	var generic_make_rect_mouseup_method = function () {
		try {
			console.log("generic_make_rect_mouseup_method");
		} catch (err) {
			console.log(err);
		}
	};

	var generic_make_rect_dblclick_method = function () {
		try {
			console.log("generic_make_rect_dblclick_method");
		} catch (err) {
			console.log(err);
		}
	};

	var generic_make_rect_mousemove_method = function (e: any, x: number, y: number) {
		try {
			if (generic_canvas_flag_first_click_rectangle) {
				cadviewer.cvjs_customCanvasMethod_globalScale();
				if (!generic_canvas_flag_rectangle) {
					cvjs_firstX = cadviewer.cvjs_SVG_x(x);
					cvjs_firstY = cadviewer.cvjs_SVG_y(y);
					cvjs_lastX = cvjs_firstX;
					cvjs_lastY = cvjs_firstY;
					generic_canvas_flag_rectangle = true;
				} else {
					// we cannot have the mouse directly on top of the rubberband path, then it will not respond
					var mousedelta = 2;
					cvjs_lastX = cadviewer.cvjs_SVG_x(x - mousedelta);
					cvjs_lastY = cadviewer.cvjs_SVG_y(y - mousedelta);
				}

				tPath_r = "M" + cvjs_firstX + "," + cvjs_firstY;
				tPath_r += "L" + cvjs_firstX + "," + cvjs_lastY;
				tPath_r += "L" + cvjs_lastX + "," + cvjs_lastY;
				tPath_r += "L" + cvjs_lastX + "," + cvjs_firstY;
				tPath_r += "L" + cvjs_firstX + "," + cvjs_firstY + " Z";
				cvjs_RubberBand.attr({ path: tPath_r });
			}
		} catch (err) {
			console.log(err);
		}
	};

	var generic_make_rect_stop_method = function () {
		// find the current highest node number
		var Node = cadviewer.cvjs_currentMaxSpaceNodeId();
		var Node_id = parseInt(Node);
		if (isNaN(Node_id)) {
			Node_id = 1;
		}

		Node_id++;
		var currentNode_underbar = "Node_" + Node_id;

		window.alert("generic_make_rect_stop_method " + currentNode_underbar);

		var loadSpaceImage_ID = (JQ("#image_ID").val() as string);
		var loadSpaceImage_Type = (JQ("#image_Type").val() as string);
		var loadSpaceImage_Layer = "cvjs_SpaceLayer";

		// create a group with space as main object
		cadviewer.cvjs_createSpaceObjectGroup(
			currentNode_underbar,
			cvjs_RubberBand,
			loadSpaceImage_ID,
			loadSpaceImage_ID,
			loadSpaceImage_Type,
			loadSpaceImage_Layer,
			"myGroup"
		);

		// make an equal rect, but with the proper color settings and controls
		var grayBox = cadviewer
			.cvjs_makeGraphicsObjectOnCanvas("Path", tPath_r)
			.attr({
				fill: "#808080",
				"fill-opacity": "1.0",
				stroke: "#000",
				"stroke-opacity": "1.0",
				"stroke-width": 0.5,
			});
		cadviewer.cvjs_addGraphicsToSpaceObjectGroup(
			currentNode_underbar,
			grayBox,
			"rect01"
		);

		cadviewer.cvjs_removeCustomCanvasMethod();
	};

	// END - SAMPLE TO CREATE RECTANGLE BY CLICK

	// SAMPLE TO CREATE RECTANGLE BY DRAG

	var generic_drag_rect_start = function () {
		generic_canvas_flag_first_click_rectangle = true;
		generic_canvas_flag_rectangle = false;

		var tPath_r = "M" + 0 + "," + 0;
		cvjs_RubberBand = cadviewer
			.cvjs_makeGraphicsObjectOnCanvas("Path", tPath_r)
			.attr({ stroke: "#b00000", fill: "none" });

		console.log("generic_start_method_01");
	};

	/**
	 * Template move drag method for custom canvas
	 */
	var generic_drag_rect_move = function (dx: number, dy: number, x: number, y: number) {
		try {
			if (generic_canvas_flag_first_click_rectangle) {
				cadviewer.cvjs_customCanvasMethod_globalScale();
				if (!generic_canvas_flag_rectangle) {
					cvjs_firstX = cadviewer.cvjs_SVG_x(x);
					cvjs_firstY = cadviewer.cvjs_SVG_y(y);
					cvjs_lastX = cvjs_firstX;
					cvjs_lastY = cvjs_firstY;
					generic_canvas_flag_rectangle = true;
				} else {
					// we cannot have the mouse directly on top of the rubberband path, then it will not respond
					var mousedelta = 1;
					cvjs_lastX = cadviewer.cvjs_SVG_x(x - mousedelta);
					cvjs_lastY = cadviewer.cvjs_SVG_y(y - mousedelta);
				}

				var tPath_r = "M" + cvjs_firstX + "," + cvjs_firstY;
				tPath_r += "L" + cvjs_firstX + "," + cvjs_lastY;
				tPath_r += "L" + cvjs_lastX + "," + cvjs_lastY;
				tPath_r += "L" + cvjs_lastX + "," + cvjs_firstY;
				tPath_r += "L" + cvjs_firstX + "," + cvjs_firstY + " Z";
				cvjs_RubberBand.attr({ path: tPath_r });
			}
		} catch (err) {
			console.log(err);
		}
	};

	/**
	 * Template stop drag method for custom canvas
	 */
	var generic_drag_rect_stop = function () {
		cvjs_RubberBand.attr({
			fill: "#99ff99",
			"fill-opacity": "0.5",
			stroke: "#ff9999",
			"stroke-opacity": "1",
		});
		cadviewer.cvjs_removeCustomCanvasMethod();
		console.log("REMOVE: generic_drag_rect_stop");
	};

	// END - SAMPLE TO CREATE RECTANGLE BY DRAG

	// SAMPLE TO DRAG RECTANGLE if overlapping space objects

	var select_drag_rect_start = function () {
		generic_canvas_flag_first_click_rectangle = true;
		generic_canvas_flag_rectangle = false;

		var tPath_r = "M" + 0 + "," + 0;
		cvjs_RubberBand = cadviewer
			.cvjs_makeGraphicsObjectOnCanvas("Path", tPath_r)
			.attr({
				fill: "#ff9999",
				"fill-opacity": "0.5",
				stroke: "#ff9999",
				"stroke-opacity": "1",
			});

		console.log("generic_start_method_01");
	};

	var select_drag_rect_move = function (dx: number, dy: number, x: number, y: number) {
		try {
			if (generic_canvas_flag_first_click_rectangle) {
				cadviewer.cvjs_customCanvasMethod_globalScale();
				if (!generic_canvas_flag_rectangle) {
					cvjs_firstX = cadviewer.cvjs_SVG_x(x);
					cvjs_firstY = cadviewer.cvjs_SVG_y(y);
					cvjs_lastX = cvjs_firstX;
					cvjs_lastY = cvjs_firstY;
					generic_canvas_flag_rectangle = true;
				} else {
					// we cannot have the mouse directly on top of the rubberband path, then it will not respond
					var mousedelta = 1;
					cvjs_lastX = cadviewer.cvjs_SVG_x(x - mousedelta);
					cvjs_lastY = cadviewer.cvjs_SVG_y(y - mousedelta);
				}

				var tPath_r = "M" + cvjs_firstX + "," + cvjs_firstY;
				tPath_r += "L" + cvjs_firstX + "," + cvjs_lastY;
				tPath_r += "L" + cvjs_lastX + "," + cvjs_lastY;
				tPath_r += "L" + cvjs_lastX + "," + cvjs_firstY;
				tPath_r += "L" + cvjs_firstX + "," + cvjs_firstY + " Z";
				cvjs_RubberBand.attr({ path: tPath_r });
			}
		} catch (err) {
			console.log(err);
		}
	};

	var select_drag_rect_stop = function () {
		cvjs_RubberBand.attr({ path: "M0,0" });
		var mybox;
		var overlap;
		var selected_list = "";

		// reorder x,  if not dragged left to right, top to buttom
		var temp;
		if (cvjs_firstX > cvjs_lastX) {
			temp = cvjs_firstX;
			cvjs_firstX = cvjs_lastX;
			cvjs_lastX = temp;
		}
		// reorder y,  if not dragged left to right, top to buttom
		if (cvjs_firstY > cvjs_lastY) {
			temp = cvjs_firstY;
			cvjs_firstY = cvjs_lastY;
			cvjs_lastY = temp;
		}

		// get all spaces
		var spaceObjectIds = cadviewer.cvjs_getSpaceObjectIdList();
		// loop over all spaces
		for (var spc in spaceObjectIds) {
			// get the bounding box of the space

			mybox = cadviewer.cvjs_getSpaceObjectBoundingBox(spaceObjectIds[spc]);
			// check if it operlaps with the drag rectangle
			if (mybox == false) continue;

			//console.log(cvjs_firstX+"  "+ cvjs_firstY+" "+ cvjs_lastX+ " "+ cvjs_lastY+"  "+spc);
			//console.log(mybox.x+" "+ mybox.y+" "+ (mybox.x+mybox.width) + " "+ (mybox.y+mybox.height));

			overlap = cadviewer.cvjs_rect_doOverlap(
				cvjs_firstX,
				cvjs_firstY,
				cvjs_lastX,
				cvjs_lastY,
				mybox.x,
				mybox.y,
				mybox.x + mybox.width,
				mybox.y + mybox.height
			);

			if (overlap) selected_list += spaceObjectIds[spc] + ";";
		}

		if (selected_list == "") selected_list = "None";

		window.alert("Selected Objects: " + selected_list);
		//cvjs_RubberBand.attr({fill: '#99ff99', "fill-opacity": "0.5", stroke: '#ff9999', 'stroke-opacity': "1"});
		cadviewer.cvjs_removeCustomCanvasMethod();
		console.log("REMOVE: generic_drag_rect_stop");
	};

	// END - SAMPLE TO DRAG RECTANGLE if overlapping space objects









	// 2025-04-11
	// custom class to highlight selected objects



	var select_drag_rect_stop_highlight = function () {
		cvjs_RubberBand.attr({ path: "M0,0" });
		var mybox;
		var overlap;
		var selected_list = "";

		// reorder x,  if not dragged left to right, top to buttom
		var temp;
		if (cvjs_firstX > cvjs_lastX) {
			temp = cvjs_firstX;
			cvjs_firstX = cvjs_lastX;
			cvjs_lastX = temp;
		}
		// reorder y,  if not dragged left to right, top to buttom
		if (cvjs_firstY > cvjs_lastY) {
			temp = cvjs_firstY;
			cvjs_firstY = cvjs_lastY;
			cvjs_lastY = temp;
		}


		var selectedList = [];

		// get all spaces
		var spaceObjectIds = cadviewer.cvjs_getSpaceObjectIdList();
		// loop over all spaces
		for (var spc in spaceObjectIds) {
			// get the bounding box of the space

			mybox = cadviewer.cvjs_getSpaceObjectBoundingBox(spaceObjectIds[spc]);
			// check if it operlaps with the drag rectangle
			if (mybox == false) continue;

			//console.log(cvjs_firstX+"  "+ cvjs_firstY+" "+ cvjs_lastX+ " "+ cvjs_lastY+"  "+spc);
			//console.log(mybox.x+" "+ mybox.y+" "+ (mybox.x+mybox.width) + " "+ (mybox.y+mybox.height));

			overlap = cadviewer.cvjs_rect_doOverlap(
				cvjs_firstX,
				cvjs_firstY,
				cvjs_lastX,
				cvjs_lastY,
				mybox.x,
				mybox.y,
				mybox.x + mybox.width,
				mybox.y + mybox.height
			);

			if (overlap) {
				selected_list += spaceObjectIds[spc] + ";";
				selectedList.push(spaceObjectIds[spc]);
			}
		}

		if (selected_list == "") selected_list = "None";

		window.alert("Selected Objects: " + selected_list + " selectedList.length" + selectedList.length);
		//cvjs_RubberBand.attr({fill: '#99ff99', "fill-opacity": "0.5", stroke: '#ff9999', 'stroke-opacity': "1"});
		cadviewer.cvjs_removeCustomCanvasMethod();


		var highlight_green = {
			fill: '#32CD32',     // 0dff8a
			"fill-opacity": 0.8,
			stroke: '#228B22',       // 0dff8a green
			'stroke-width': 2.0,
			'stroke-opacity': 1,
			'stroke-linejoin': 'round'
		};



		for (var i = 0; i < selectedList.length; i++) {

			cadviewer.cvjs_highlightSpace(selectedList[i], highlight_green);

		}


		console.log("REMOVE: generic_drag_rect_stop");
	};










	// SAMPLE TO CREATE RECTANGLE w TEXT and ARRow BY CLICK

	var logic_flags = [false, false, false, false, false, false];
	var operation_type = "";
	var mybasewidth = 1;

	var generic_make_rect_arrow_init_method = function () {
		console.log("generic_make_rect_init_method");
		logic_flags = [false, false, false, false, false, false];
		operation_type = "box";
	};

	var tPath_r = "";

	var generic_make_rect_arrow_mousedown_method = function (e: any, x: number, y: number) {
		try {
			if (
				operation_type.indexOf("arrow") == 0 &&
				logic_flags[0] &&
				logic_flags[1]
			) {
				generic_make_rect_arrow_stop_method2();
			}

			if (operation_type.indexOf("box") == 0 && !logic_flags[0]) {
				// first box
				var tPath_r = "M" + 0 + "," + 0;
				cvjs_RubberBand = cadviewer
					.cvjs_makeGraphicsObjectOnCanvas("Path", tPath_r)
					.attr({ stroke: "#b00000", fill: "none" });
				logic_flags[0] = true;
				logic_flags[1] = false;
			}
			if (
				operation_type.indexOf("box") == 0 &&
				logic_flags[0] &&
				logic_flags[1]
			) {
				generic_make_rect_arrow_stop_method1();
			}
		} catch (err) {
			console.log(err);
		}
		//console.log("mouse down ");
	};

	var generic_make_rect_arrow_mouseup_method = function () {
		try {
			console.log("generic_make_rect_mouseup_method");
		} catch (err) {
			console.log(err);
		}
	};

	var generic_make_rect_arrow_dblclick_method = function () {
		try {
			console.log("generic_make_rect_dblclick_method");
		} catch (err) {
			console.log(err);
		}
	};

	var generic_make_rect_arrow_mousemove_method = function (e: any, x: number, y: number) {
		try {
			if (operation_type.indexOf("box") == 0 && logic_flags[0]) {
				cadviewer.cvjs_customCanvasMethod_globalScale();
				if (!logic_flags[1]) {
					cvjs_firstX = cadviewer.cvjs_SVG_x(x);
					cvjs_firstY = cadviewer.cvjs_SVG_y(y);
					cvjs_lastX = cvjs_firstX;
					cvjs_lastY = cvjs_firstY;
					logic_flags[1] = true;
				} else {
					// we cannot have the mouse directly on top of the rubberband path, then it will not respond
					var mousedelta = 1;
					cvjs_lastX = cadviewer.cvjs_SVG_x(x - mousedelta);
					cvjs_lastY = cadviewer.cvjs_SVG_y(y - mousedelta);
				}

				tPath_r = "M" + cvjs_firstX + "," + cvjs_firstY;
				tPath_r += "L" + cvjs_firstX + "," + cvjs_lastY;
				tPath_r += "L" + cvjs_lastX + "," + cvjs_lastY;
				tPath_r += "L" + cvjs_lastX + "," + cvjs_firstY;
				tPath_r += "L" + cvjs_firstX + "," + cvjs_firstY + " Z";
				cvjs_RubberBand.attr({ path: tPath_r });
			}

			if (operation_type.indexOf("arrow") == 0 && logic_flags[0]) {
				cadviewer.cvjs_customCanvasMethod_globalScale();

				logic_flags[1] = true;
				var mousedelta = 1;
				cvjs_lastX = cadviewer.cvjs_SVG_x(x - mousedelta);
				cvjs_lastY = cadviewer.cvjs_SVG_y(y - mousedelta);

				tPath_r = "M" + cvjs_firstX + "," + cvjs_firstY;
				tPath_r += "L" + cvjs_lastX + "," + cvjs_lastY;
				cvjs_RubberBand.attr({ path: tPath_r });
			}
		} catch (err) {
			console.log(err);
		}
	};

	var randomNr = 0;

	var generic_make_rect_arrow_stop_method1 = function () {
		// find the current highest node number
		var Node = cadviewer.cvjs_currentMaxSpaceNodeId();
		var Node_id = parseInt(Node);
		if (isNaN(Node_id)) {
			Node_id = 1;
		}

		Node_id++;
		var currentNode_underbar = "Node_" + Node_id;

		randomNr = Math.floor(Math.random() * Math.floor(100000));
		window.alert("randomNr " + randomNr);

		cvjs_RubberBand.attr({
			fill: "none",
			"fill-opacity": "0.5",
			stroke: "#0000b0",
			"stroke-opacity": "1",
		});
		// create a group with space as main object
		cadviewer.cvjs_createSpaceObjectGroup(
			currentNode_underbar,
			cvjs_RubberBand,
			"API" + randomNr,
			"API" + randomNr,
			"Generic",
			"myLayer",
			"myGroup"
		);

		// create a new border object as separate graphics - we use the rubberband as our graphics variable
		cvjs_RubberBand = cadviewer
			.cvjs_makeGraphicsObjectOnCanvas("Path", tPath_r)
			.attr({
				fill: "none",
				"fill-opacity": "1",
				stroke: "#000",
				"stroke-opacity": "1",
				"stroke-width": mybasewidth,
			});
		cadviewer.cvjs_addGraphicsToSpaceObjectGroup(
			currentNode_underbar,
			cvjs_RubberBand,
			"rect01"
		);

		// create the text string add add to graphics group
		var myText = cadviewer
			.cvjs_makeTextObjectOnCanvas(
				cvjs_firstX + (cvjs_lastX - cvjs_firstX) / 10.0,
				cvjs_lastY - (cvjs_lastY - cvjs_firstY) / 5.0,
				"API" + randomNr
			)
			.attr({
				fill: "#000",
				"fill-opacity": "1",
				stroke: "#000",
				"font-size": Math.abs(cvjs_lastY - cvjs_firstY) / 2.0,
			});
		cadviewer.cvjs_addGraphicsToSpaceObjectGroup(
			currentNode_underbar,
			myText,
			"text01"
		);

		// we change to arrow, and directly make the mouse draggable
		operation_type = "arrow";
		logic_flags[0] = true;
		logic_flags[1] = false;

		// set rubberband to middle of box side
		cvjs_firstX = (cvjs_firstX + cvjs_lastX) / 2.0;
		cvjs_firstY = cvjs_lastY;
		// make new rubberband
		tPath_r = "M" + cvjs_firstX + "," + cvjs_firstY;
		cvjs_RubberBand = cadviewer
			.cvjs_makeGraphicsObjectOnCanvas("Path", tPath_r)
			.attr({ stroke: "#b00000", fill: "none" });
	};

	var generic_make_rect_arrow_stop_method2 = function () {
		cvjs_RubberBand.attr({
			fill: "none",
			"fill-opacity": "1",
			stroke: "#000",
			"stroke-opacity": "1",
			"stroke-width": mybasewidth,
		});
		// we create an arrow object and add to space object

		// here we have to add the graphical object to our already created object
		var Node = cadviewer.cvjs_currentMaxSpaceNodeId();
		var Node_id = parseInt(Node);
		if (isNaN(Node_id)) {
			Node_id = 1;
		}

		var currentNode_underbar = "Node_" + Node_id;

		cadviewer.cvjs_addGraphicsToSpaceObjectGroup(
			currentNode_underbar,
			cvjs_RubberBand,
			"arrow-line01"
		);

		// create an arrow
		var angleInDegrees =
			(Math.atan2(cvjs_lastY - cvjs_firstY, cvjs_lastX - cvjs_firstX) / Math.PI) *
			180.0;
		var scaleTriangle = mybasewidth; // same as stroke-width
		var triangle_design =
			-5.0 * scaleTriangle +
			"," +
			5.5 * scaleTriangle +
			" " +
			0.0 * scaleTriangle +
			"," +
			-4.5 * scaleTriangle +
			" " +
			5.0 * scaleTriangle +
			"," +
			5.5 * scaleTriangle;
		var mysin = Math.sin((angleInDegrees / 180) * Math.PI);
		var mycos = Math.cos((angleInDegrees / 180) * Math.PI);
		var Ttrans =
			"r" +
			(angleInDegrees - 270) +
			"T" +
			(cvjs_lastX + mycos * scaleTriangle) +
			"," +
			cvjs_lastY;
		var Triangle = cadviewer.cvjs_makeGraphicsObjectOnCanvas(
			"Polyline",
			triangle_design
		);
		Triangle.attr({
			fill: "none",
			"fill-opacity": "1",
			stroke: "#000",
			"stroke-opacity": "1",
			"stroke-width": mybasewidth,
		});
		Triangle.attr({
			fill: "#000",
			transform: Ttrans,
		});

		// here we add an arrow to the object
		cadviewer.cvjs_addGraphicsToSpaceObjectGroup(
			currentNode_underbar,
			Triangle,
			"arrow01"
		);




		/*
	
	
		//NOTE:  IF THE CADViewer callback method is not exported from this component, then we need to catch it
		try {
	//		this.cvjs_graphicalObjectOnChange(
				CV.cvjs_graphicalObjectOnChange(
				"Create",
				"CustomObject",
				"API" + randomNr
			);
		} catch (err) {
			console.log("cvjs_graphicalObjectOnChange: arrow method:" + err);
		}
		cadviewer.cvjs_removeCustomCanvasMethod();
	
	
		*/






	};

	// END OF DRAG

	// CLICK TO SELECT HANDLES

	// NOTE  - for Handles to be processed in DWG conversion, the conversion parameter -hlall  must be set:
	// USE THIS FOR PROCESSING AUTOCAD HANDLES
	// include this:         cadviewer.cvjs_conversion_addAXconversionParameter("hlall", "");

	// USE THESE TO PROCESS LAYERS RM_ AND RM_TXT FOR INTERACTIVE HIGHLIGHT
	// optional:       cadviewer.cvjs_conversion_addAXconversionParameter("rl", "RM_");
	// optional:		cadviewer.cvjs_conversion_addAXconversionParameter("tl", "RM_TXT");

	var generic_handles_init_method_01 = function () {
		selected_handles = [];
		// we want to send click object to back!!!!!!
		// so we can click on Handle Objects
		cadviewer.cvjs_sendCustomCanvasToBack("floorPlan");
		handle_selector = true;
	};

	/**
	 * Template mouse-move method for custom canvas
	 */

	var generic_handles_mousemove_method_01 = function (e: any, x: number, y: number) {
		var svg_x = cadviewer.cvjs_SVG_x(x);
		var svg_y = cadviewer.cvjs_SVG_y(y);

		//cadviewer.cvjs_removeCustomCanvasMethod();
		// console.log("generic_mousemove_method_01: x="+x+" y="+y+" svg_x="+svg_x+"  svg_y="+svg_y);
	};

	/**
	 * Template mouse-down method for custom canvas
	 */

	var generic_handles_mousedown_method_01 = function (e: any, x: number, y: number) {
		var svg_x = cadviewer.cvjs_SVG_x(x);
		var svg_y = cadviewer.cvjs_SVG_y(y);

		// cadviewer.cvjs_removeCustomCanvasMethod();
		// onsole.log("generic_mousedown_method_01: x="+x+" y="+y+" svg_x="+svg_x+"  svg_y="+svg_y);
	};

	/**
	 * Template mouse-up method for custom canvas
	 */

	var generic_handles_mouseup_method_01 = function (e: any, x: number, y: number) {
		var svg_x = cadviewer.cvjs_SVG_x(x);
		var svg_y = cadviewer.cvjs_SVG_y(y);

		// console.log("generic_mouseup_method_01: x="+x+" y="+y+" svg_x="+svg_x+"  svg_y="+svg_y);
	};

	/**
	 * Template double-click method for custom canvas
	 */

	var generic_handles_dblclick_method_01 = function (e: any, x: number, y: number) {
		cadviewer.cvjs_removeCustomCanvasMethod();
		handle_selector = false;

		var mystring = "";
		for (var spc in selected_handles) {
			// we find all handles
			mystring += selected_handles[spc].handle + ";";
			// we need to clean out highlighted handles
			cadviewer.cvjs_mouseout_handleObjectStyles(
				selected_handles[spc].id,
				selected_handles[spc].handle
			);
		}

		window.alert(mystring);

		var svg_x = cadviewer.cvjs_SVG_x(x);
		var svg_y = cadviewer.cvjs_SVG_y(y);
		console.log(
			"REMOVE: generic_dblclick_method_01: x=" +
			x +
			" y=" +
			y +
			" svg_x=" +
			svg_x +
			"  svg_y=" +
			svg_y
		);
	};

	// END - SAMPLE TO DRAG RECTANGLE over HANDLES


	/////////  CANVAS CONTROL METHODS END




	const addIcons = useCallback(() => {


		var currentTime1 = new Date();

		var loadSpaceImage_Location = "data:image/svg+xml;base64, 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"
		var baseobject = "http://localhost:3000/content/customInsertSpaceObjectMenu/images/sensor_c.svg"
		var id = "myID_" + Math.floor(Math.random() * 1000000000);
		var type = "sensor";
		var layer = "mylayer";
		var xpos = Math.floor(Math.random() * 1000);
		var ypos = Math.floor(Math.random() * 500) + 310;

		var counter = 10;  //500

		cadviewer.cvjs_setComputeSpaceObjectParentStatus(false);

		for (var i = 0; i < counter; i++) {

			console.log("LOOP COUNTER i=" + i);

			xpos = Math.floor(Math.random() * 1350);
			ypos = Math.floor(Math.random() * 500) + 310;

			let result = "";
			let length = 10;
			const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			const charactersLength = characters.length;
			let counter = 0;
			while (counter < length) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength));
				counter += 1;
			}


			id = "myID_" + result;
			type = "sensor";
			layer = "mylayer";

			console.log("LOOP COUNTER i=" + i + " id=" + id);

			cadviewer.cvjs_setImageSpaceObjectParameters(baseobject, id, type, layer);
			//cvjs_setImageSpaceObjectParameters(loadSpaceImage_Location, id, type, layer);
			cadviewer.cvjs_setGlobalSpaceImageObjectScaleFactor(0.25);

			//console.log("cvjs_addFixedSizeImageSpaceObjectXY");
			cadviewer.cvjs_addFixedSizeImageSpaceObjectXY("floorPlan", xpos, ypos)
			//cvjs_addFixedSizeImageSpaceObject("floorPlan");
		}

		var currentTime2 = new Date();

		//var delta = currentTime2 - currentTime1;

		console.log("COLOR + LINEWEIGHT, number of objects:" + counter + " millisec:"); // + delta);


	}, [currentCanvasInstance]);



	return (
		<>
			<br />
			<strong className={`
                    bg-white text-black font-normal rounded 
                    ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                `}>Custom Interactive Canvas Samples:&nbsp;</strong>
			<button className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                `}
				onClick={cadviewerCanvasMethod01}
			>
				Canvas-DRAG (console)
			</button>
			<button className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                `}
				onClick={cadviewerCanvasMethod02}
			>
				Canvas-CLICK (console)
			</button>
			<button className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                `}
				onClick={cadviewerCanvasMethod03}
			>
				Make Rect -CLICK
			</button>
			<button
				className={`
                     bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                     ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                 `}
				onClick={cadviewerCanvasMethod04}
			>
				Make Rect -DRAG
			</button>
			<button className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                `}
				onClick={cadviewerCanvasMethod05}
			>
				Select Spaces -DRAG (rl/tl in ax2025)
			</button>
			<button className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                `}
				onClick={cadviewerCanvasMethod05A}
			>
				Select and highlight Spaces -DRAG
			</button>

			<button className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                `}
				onClick={cadviewerCanvasMethod06}
			>
				Make Box/Arrow Canvas-CLICK
			</button>
			<button className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                `}
				onClick={cadviewerCanvasMethod07}
			>
				Select Handles -CLICK (DblClick End) (hlall in ax2025)
			</button>

			<button className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                `}
				onClick={addIcons}
			>
				addIcons
			</button>




		</>
	);
};
